import React from 'react';

/** Title removed — page uses topbar context only. */
const CalendarPageHeader: React.FC = () => null;

export default CalendarPageHeader;
